/**
 * Prod/Default app configuration
 */
import { DeviceFamilies, StripePricingIdsProd } from "@Enums";
import Regions from "./regions";

export default {
  // Firebase App Config
  apiKey: "AIzaSyCO7-TOoaB8fg0oBKKVz7mcf3DtDKniSZc",
  authDomain: "be-your-best-web-portal.firebaseapp.com",
  databaseURL: "https://be-your-best-web-portal.firebaseio.com",
  projectId: "be-your-best-web-portal",
  storageBucket: "be-your-best-web-portal.appspot.com",
  messagingSenderId: "765417751240",
  measurementId: "G-7532S5YSX6",
  appId: "1:765417751240:web:0e5785e18d0be782",
  // Region is used by the Frontend app to point to correct zone where Backend functions & Hosting is deployed (Important to remain in EU for data privacy)
  region: Regions.EUROPE_WEST_1,
  // Stripe Config
  stripeApiKey: "pk_live_51HIBL7Jxfuw0gUiigPIKnqjsfBcpY8gCVWfJUJIwU0SSn4brVENFRMX7ewsqtpUaWo6aXW76WEjxfIQjYsDbwRsV00JXo47u0K",
  stripePricingIds: StripePricingIdsProd,
  // Used to check if Unity client version is too old and requires an update notification on startup
  minimumClientVersion: "2.10.3",
  // Same as above by acts as the default client version for standalone web & development configured apps
  placeholderClientVersion: "100.100.100",
  // Used only for identifying the current web app version, currently has no impact on user or app operation
  webVersion: "2.11.0",
  // Maintenance Mode used for blocking web app access during schedules maintainence tasks where the app must be fully blocked
  maintenanceModeEnabled: false,
  serviceOutageBlocker: false,
  platformConfigs: {
    [DeviceFamilies.Oculus]: {
      minimumClientVersion: "2.18.0",
      maintenanceModeEnabled: false,
      serviceOutageBlocker: false,
      applicationIdentifiers: {
        "com.beyourbest.vision": "4023081667710848",
        "com.beyourbest.visionxr": "5105468496138399",
      },
    },
    [DeviceFamilies.Windows]: {
      minimumClientVersion: "2.15.1",
      maintenanceModeEnabled: false,
      serviceOutageBlocker: false,
    },
    [DeviceFamilies.OSX]: {
      minimumClientVersion: "2.15.1",
      maintenanceModeEnabled: false,
      serviceOutageBlocker: false,
    },
    [DeviceFamilies.Pico]: {
      minimumClientVersion: "2.6.5",
      maintenanceModeEnabled: false,
      serviceOutageBlocker: true,
      applicationIdentifiers: {
        "com.beyourbest.vision": "fc741fd0c4fa3592fe463d343bc13a7f",
      },
    },
    [DeviceFamilies.Unknown]: {
      minimumClientVersion: "2.15.1",
      maintenanceModeEnabled: false,
      serviceOutageBlocker: false,
    },
    [DeviceFamilies.Android]: {
      minimumClientVersion: "2.11.0",
      maintenanceModeEnabled: false,
      serviceOutageBlocker: false,
    },
    [DeviceFamilies.iOS]: {
      minimumClientVersion: "2.11.0",
      maintenanceModeEnabled: false,
      serviceOutageBlocker: false,
    },
    [DeviceFamilies.None]: {
      minimumClientVersion: "2.10.3",
      maintenanceModeEnabled: false,
      serviceOutageBlocker: false,
    },
    [DeviceFamilies.Web]: {
      minimumClientVersion: "2.10.3",
      maintenanceModeEnabled: false,
      serviceOutageBlocker: false,
    },
  },
  // Amplitude API Key
  amplitude_api_key: "bb92e7668d9b16dee8132523a3079c85",
  // Snapchat Pixel ID
  snapchat_pixel_id: "9dda1f4a-959b-4921-ab00-ad09184bf417",
  // Facebook Pixel ID
  facebook_pixel_id: "275101196855193",
};
